import { StandardResult } from '@calculations/utilities/result';
import { dec, Decimal } from '@snap-types/types/decimal';
import { err, ok } from 'neverthrow';

export function parseToDecimal(input: string): StandardResult<Decimal> {
  try {
    return ok(dec(input));
  } catch (e: unknown) {
    if (e instanceof Error && /DecimalError/.test(e.message)) {
      return err({
        message: 'Not a valid decimal number',
        context: { input },
      });
    } else {
      throw e;
    }
  }
}

export function parseToNumber(input: string): StandardResult<number> {
  const parsed = parseFloat(input);

  if (Number.isNaN(parsed)) {
    return err({
      message: 'Not a valid number',
      context: {
        input,
        parsed,
      },
    });
  }

  return ok(parsed);
}
